import React, { FC } from 'react';
import locales from '../../../content.json';
import s from './index.module.scss';

type BarTone = 'orange' | 'purple';

interface IProgressSection {
  title: string;
  now: number[];
  withEverydoggy: number[];
}

interface IProgressBarsProps {
  values: number[];
  tone: BarTone;
}

const SparkleIcon: FC = () => (
  <svg viewBox="0 0 16 16" className={s.sparkle} aria-hidden="true">
    <path
      d="M8 0.75c0.31 0 0.58 0.21 0.66 0.52L9.93 5.8l4.53 1.27c0.31 0.09 0.52 0.35 0.52 0.66s-0.21 0.58-0.52 0.66L9.93 9.66l-1.27 4.53a0.687 0.687 0 0 1-1.32 0L6.07 9.66 1.54 8.39A0.687 0.687 0 0 1 1.54 7.07L6.07 5.8l1.27-4.53A0.69 0.69 0 0 1 8 0.75Z"
      fill="currentColor"
    />
  </svg>
);

const ProgressBars: FC<IProgressBarsProps> = ({ values, tone }) => {
  const trackClassName = tone === 'orange' ? s.segmentTrackOrange : s.segmentTrackPurple;
  const fillClassName = tone === 'orange' ? s.segmentFillOrange : s.segmentFillPurple;

  return (
    <div className={s.barGroup}>
      {values.map((value, index) => (
        <div key={`${tone}-${index}`} className={`${s.segmentTrack} ${trackClassName}`}>
          {value > 0 && (
            <span
              className={`${s.segmentFill} ${fillClassName}`}
              style={{ width: `${Math.max(0, Math.min(1, value)) * 100}%` }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export const DogTranslatorGraphs: FC = () => {
  const lang =
    typeof window !== 'undefined' && window.userLang && locales[window.userLang]
      ? window.userLang
      : 'en';

  const localeData = locales[lang];
  const dict = localeData.payment_text_304 ? localeData : locales.en;

  const sections: IProgressSection[] = [
    {
      title: dict.payment_text_306,
      now: [1, 0, 0],
      withEverydoggy: [1, 1, 0.72],
    },
    {
      title: dict.payment_text_307,
      now: [0.62, 0, 0],
      withEverydoggy: [1, 1, 0.52],
    },
    {
      title: dict.payment_text_308,
      now: [1, 0.44, 0],
      withEverydoggy: [1, 1, 0.72],
    },
    {
      title: dict.payment_text_309,
      now: [1, 0, 0],
      withEverydoggy: [1, 1, 1],
    },
  ];

  return (
    <section className={s.wrapper}>
      <div className={s.badge}>
        <SparkleIcon />
        <span>{dict.payment_text_303}</span>
        <SparkleIcon />
      </div>

      <div className={s.card}>
        <h2 className={s.title}>{dict.payment_text_304}</h2>

        <div className={s.content}>
          <div className={s.tabs}>
            <div className={s.tabSlot}>
              <span className={`${s.tab} ${s.tabNow}`}>{dict.payment_text_305}</span>
            </div>
            <div className={s.tabSlot}>
              <span className={`${s.tab} ${s.tabEverydoggy}`}>{dict.payment_text_58}</span>
            </div>
          </div>

          <div className={s.sections}>
            {sections.map((section) => (
              <div key={section.title} className={s.section}>
                <h3 className={s.sectionTitle}>{section.title}</h3>
                <div className={s.barsRow}>
                  <ProgressBars values={section.now} tone="orange" />
                  <ProgressBars values={section.withEverydoggy} tone="purple" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

